var map = {
	"./avatar1.png": 35,
	"./avatar2.png": 36,
	"./avatar3.png": 37,
	"./avatar4.png": 38,
	"./avatar5.png": 39,
	"./avatar6.png": 40
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6;


//////////////////
// WEBPACK FOOTER
// ./src/avatars ^\.\/.*$
// module id = 6
// module chunks = 0